'use client';

export default function ProductError({ reset }) {
  return (
    <div className="py-20 text-center bg-warm-white min-h-[50vh] flex flex-col items-center justify-center gap-4">
      <p className="font-cormorant text-2xl text-primary">Something went wrong loading this product.</p>
      <button
        onClick={reset}
        className="text-sm underline text-sea"
      >
        Try again
      </button>
    </div>
  );
}
